import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { SymbologysService, LBSymbology } from './symbologys.service';


@Injectable()
export class ResolverSymbologysService implements Resolve<LBSymbology[]> {

	constructor(
		private symbService: SymbologysService
	) { }
	async resolve() {
		let symbs;
		try {
			symbs = await this.symbService.getSymbologys();
		} catch (err) {
			symbs = [];
			throw err;
		}
		return symbs;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-symbologys.service.ts